import { Fragment } from 'react';

import I18n from '~/src/common/services/I18n';
import { RecipeBasicIngredient } from '~/src/screens/CatalogContent/ContentScreen/RecipeScreen/types';

import * as GS from '../../layout';

import * as S from './layout';

interface Props {
  ingredients: RecipeBasicIngredient[];
  servings: number;
}

const RecipeIngredients = ({ ingredients, servings }: Props) => {
  return (
    <section>
      <GS.SectionName>{I18n.t('recipe-screen.ingredients-title')}</GS.SectionName>
      <S.IngredientsContainer>
        <p>{I18n.translate({ value: 'recipe-screen.portions-quantities', count: servings })}</p>
        <S.IngredientsInnerContainer>
          {ingredients.length > 0
            ? ingredients.map(i => (
                <Fragment key={i.id}>
                  <dt>{i.name}</dt>
                  <dd>{`${i.amount ? `${i.amount} ` : ''}${i.measurement ?? ''}`}</dd>
                </Fragment>
              ))
            : I18n.t('recipe-screen.no-ingredient')}
        </S.IngredientsInnerContainer>
      </S.IngredientsContainer>
    </section>
  );
};

export default RecipeIngredients;
